import { Component, OnInit } from "@angular/core";
import { Global } from "src/app/global";
import { ApiService } from "src/app/service/apiServices";
import Swal from "sweetalert2";
// Import Bootstrap JS types for TypeScript
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Declare bootstrap for TypeScript
declare var bootstrap: any;

@Component({
  selector: "app-configuracao-previne-brasil",
  templateUrl: "./configuracao-previne-brasil.component.html",
  styleUrls: ["./configuracao-previne-brasil.component.css"],
})
export class ConfiguracaoPrevineBrasilComponent implements OnInit {
  loading: boolean = false;
  listaConfiguracoesPrevineBrasil: any[] = [];
  pagina: any = 1;
  totalPagina: any = 1;
  itensPorPagina: any = 10;
  mostrarColunasCFA: boolean = false;
  mostrarColunasCFAO: boolean = false;

  formulario: any = {
    nome_quadrimestre: null,
    data_inicial: null,
    data_final: null,
    processar_idoso: true,
    processar_cancer: true,
    processar_crianca: true,
    processar_hipertenso: true,
    processar_diabete: true,
    processar_gestante: true,
    processar_mais_acesso: true,
    processar_crianca_geral: true,
    processar_gestante_geral: true,
    processar_odonto_escovacao_supervisionada: true,
    processar_odonto_primeira_consulta: true,
    processar_odonto_procedimento_preventivo: true,
    processar_odonto_taxa_exodontia: true,
    processar_odonto_tratamento_concluido: true,
    processar_odonto_tratamento_restaurador: true,
    processar_emult_media_atendimento: true,
    processar_emult_acao_interprofissional: true
  };

  tiposProcessamento = [{ value: 1, label: "Processar Idoso" }];
  tipoSelecionado: any = null;
  itemEditar: any = null;
  tipoEditarSelecionado: any = null;

  constructor(public global: Global, public service: ApiService) {}

  ngOnInit() {
    this.listarRegistrosPrevineBrasil();
  }

  listarRegistrosPrevineBrasil() {
    this.loading = true;
    this.service
      .Get("ConfiguracaoPrevineBrasil?Skip=1&Take=50")
      .then((res: any) => {
        this.listaConfiguracoesPrevineBrasil = res.conteudo;
        this.totalPagina = res.quantidade_total;
        this.loading = false;
      })
      .catch((err) => {
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro na busca.",
          icon: "error",
        });
      });
  }
  salvar() {
    this.loading = true;  
    if (!this.validarRequisicaoIntervaloDatas()) return;

    this.service
      .Post("ConfiguracaoPrevineBrasil", this.formulario)
      .then((res: any) => {
        this.loading = false;
        this.formulario = {
          nome_quadrimestre: null,
          data_inicial: null,
          data_final: null,
          processar_idoso: true,
          processar_cancer: true,
          processar_crianca: true,
          processar_hipertenso: true,
          processar_diabete: true,
          processar_gestante: true,
          processar_mais_acesso: true,
          processar_crianca_geral: true,
          processar_odonto_escovacao_supervisionada: true,
          processar_odonto_primeira_consulta: true,
          processar_odonto_procedimento_preventivo: true,
          processar_odonto_taxa_exodontia: true,
          processar_odonto_tratamento_concluido: true,
          processar_odonto_tratamento_restaurador: true,
          processar_emult_media_atendimento: true,
          processar_emult_acao_interprofissional: true
        };
        Swal.fire({
          title: "Sucesso!",
          text: "Registro salvo com sucesso.",
          icon: "success",
        });
        this.listarRegistrosPrevineBrasil();
      })
      .catch((err) => {
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro ao salvar o registro.",
          icon: "error",
        });
        this.loading = false;
      });
  }

  deletarRegistro(id) {
    Swal.fire("Favor aguarde");
    Swal.showLoading();

    this.service
      .Delete(`ConfiguracaoPrevineBrasil/${id}`)
      .then((res: any) => {
        this.loading = false;
        Swal.fire({
          title: "Sucesso!",
          text: "Registro excluído com sucesso.",
          icon: "success",
        });
        this.listarRegistrosPrevineBrasil();
      })
      .catch((err) => {
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro ao excluir o registro.",
          icon: "error",
        });
        this.loading = false;
      });
  }
  editarRegistro(registro: any) {
    this.itemEditar = registro;
  }

  salvarEdicao() {
    this.loading = true;    
    if (!this.validarRequisicaoIntervaloDatas()) return;

    this.service
      .Put(`ConfiguracaoPrevineBrasil/${this.itemEditar.id}`, this.itemEditar)
      .then((res: any) => {
        this.loading = false;
        this.listarRegistrosPrevineBrasil();

        Swal.fire({
          title: "Sucesso!",
          text: "Registro editado com sucesso.",
          icon: "success",
        }).then(() => {
          // Fecha o modal pelo id
          const modalElement = document.getElementById(
            "modalEditarConfiguracao"
          );
          if (modalElement) {
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
              modalInstance.hide();
            }
            this.itemEditar = null;
          }
        });
      })
      .catch((err) => {
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro ao editar o registro.",
          icon: "error",
        });
        this.loading = false;
      });
  }
  validarRequisicaoIntervaloDatas(): boolean {
    if (this.itemEditar !== null) {
      if (this.itemEditar.data_inicial > this.itemEditar.data_final) {
        Swal.fire({
          title: "Erro!",
          text: "A data inicial não pode ser maior que a data final.",
          icon: "error",
        });
        this.loading = false;
        return false;
      }
    } else {
      if (this.formulario !== null) {
        if (this.formulario.data_inicial > this.formulario.data_final) {
          Swal.fire({
            title: "Erro!",
            text: "A data inicial não pode ser maior que a data final.",
            icon: "error",
          });
          this.loading = false;
          return false;
        }
      }
    }
    return true;
  }
  formatarDataParaInput(dataISO: string): string {
    if (!dataISO) return "";
    const data = new Date(dataISO);
    const ano = data.getFullYear();
    const mes = (data.getMonth() + 1).toString().padStart(2, "0");
    const dia = data.getDate().toString().padStart(2, "0");
    return `${ano}-${mes}-${dia}`;
  }
  processarRegistro(item: any) {
    this.loading = true;
    this.service
      .Patch_body(`ConfiguracaoPrevineBrasil/${item.id}/Processar`, {})
      .then((res: any) => {
        this.loading = false;
        Swal.fire({
          title: "Sucesso!",
          text: "Registro em processamento",
          icon: "success",
        });
        this.listarRegistrosPrevineBrasil();
      })
      .catch((err) => {
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro ao processar o registro.",
          icon: "error",
        });
        this.loading = false;
      });
  }
}
